//Navigations
if (typeof gsap !== 'undefined') {
	gsap.config({ nullTargetWarn: false })
}
var openMenus = document.querySelectorAll('.open-menu')
var container = document.querySelector('.content')
var body = document.body
function scrollControl() {
	if (container.classList.contains('menu-open')) {
		var scrollY = document.documentElement.style.getPropertyValue('--scroll-y')
		body.style.position = 'fixed'
		body.style.width = '99%'
		body.style.right = '1%'
		body.style.top = '-'.concat(scrollY)
	}
	else {
		var scrollY = body.style.top
		body.style.position = ''
		body.style.width = ''
		body.style.right = ''
		body.style.top = ''
		window.scrollTo(0, parseInt(scrollY || '0') * -1)
	}
	window.addEventListener('scroll', function () {
		document.documentElement.style.setProperty('--scroll-y', ''.concat(window.scrollY, 'px'))
	})
}

for (let i = 0; i < openMenus.length; i++) {
	const currentOpen = openMenus[i]
	const nextNode = currentOpen.nextElementSibling
	const closeMenu = nextNode.querySelector('.close-menu')
	var mobileWidth = '100%'
	var desktopWidth = '50%'
	function setWidth() {
		if (window.matchMedia('(min-width:1024px)').matches) {
			return desktopWidth
		}
		return mobileWidth
	}
	function resizeWidth() {
		window.addEventListener('resize', function () {
			if (nextNode.classList.contains('open') && (window.matchMedia('(min-width:1025px)').matches)) {
				nextNode.style.width = '50%'
			} else if (nextNode.classList.contains('open') && (window.matchMedia('(max-width:1024px)').matches)) {
				nextNode.style.width = '100%'
			} else {
				nextNode.style.width = '0'
			}
		})
	}
	const tween = gsap.to(nextNode, {
		duration: .6,
		width: setWidth(),
		paused: true,
		reversed: true,
		ease: 'power4.in',
		onStart: () => {
			nextNode.classList.remove('closed')
		},
		onComplete: () => {
			const parentId = nextNode.id
			const currentClass = nextNode.getAttribute('class')
			if (currentClass.includes('open')) {
				HAHAccessibility.trapFocus({
					container: `#${parentId}`,
					closeElement: '.close-menu',
					firstElementToFocus: '.ADA_firstElement',
					unbindEvents: true
				})
			}
			currentOpen.setAttribute('aria-expanded', 'true')
			$(currentOpen).one('blur', () => {
				currentOpen.setAttribute('aria-label', 'Close Menu')
				currentOpen.removeAttribute('aria-haspopup')
				currentOpen.removeAttribute('aria-expanded')
			})
		},
		onReverseComplete: () => {
			nextNode.classList.add('closed')
			const parentClass = currentOpen.parentElement.getAttribute('class')
			currentOpen.setAttribute('aria-expanded', 'false')
			currentOpen.setAttribute('aria-haspopup', 'dialog')
			if (parentClass === 'search') {
				currentOpen.setAttribute('aria-label', 'Search Menu')
			} else if (parentClass === 'global-sites') {
				currentOpen.setAttribute('aria-label', 'Languages Menu')
			} else if (parentClass === 'hdr-account') {
				currentOpen.removeAttribute('aria-label')
			}
		}
	})

	// For all currentOpen items, except Bonvoy Points Login
	if (currentOpen.id !== 'btn_login_points') {
		const children = nextNode.querySelectorAll('[data-animate="true"]')
		const childTween = gsap.timeline()
		gsap.set(children, {
			opacity: 0,
			x: 180,
		})
		gsap.set(closeMenu, {
			opacity: 0
		})
		function open() {
			childTween.timeScale(1)
			childTween.to(children, {
				opacity: 1,
				x: 0,
				duration: 0.5,
				delay: 0.6,
				stagger: 0.025,
				ease: 'power1.out',
				overwrite: 'auto',
			}).to(closeMenu, {
				opacity: 1,
				rotation: 360
			})
		}
		function close() {
			childTween.timeScale(99)
			childTween.to(children, {
				opacity: 0,
				x: 180,
				duration: 0.2,
				ease: 'power1.out',
				overwrite: 'auto',
			}).to(closeMenu, {
				opacity: 0,
				rotation: 0
			})
		}
		function clickMenu(event) {
			setTimeout(function () {
				document.getElementById('tSearchString').focus()
			}, 1000)
			nextNode.classList.toggle('open')
			container.classList.toggle('menu-open')
			tween.reversed() ? tween.play() : tween.reverse()
			tween.reversed() ? close() : open()
			//scrollControl()
			resizeWidth()
			
			if (nextNode.classList.contains('open')) {
				document.addEventListener('click', closeMenuIfClickOutside)
			} else {
				document.removeEventListener('click', closeMenuIfClickOutside)
			}
		}
		function closeMenuIfClickOutside(event) {
			if (!nextNode.contains(event.target) && !currentOpen.contains(event.target)) {
				if (nextNode.classList.contains('open')) {
					currentOpen.click()
				}
				document.removeEventListener('click', closeMenuIfClickOutside)
			}
		}

		currentOpen.addEventListener('click', clickMenu)

		closeMenu?.addEventListener('click', clickMenu)
	
	}
}

/*Pinned Header */
checkOffset()
$(window).on('scroll', function () {
	checkOffset()
})
function checkOffset() {
	if (window.scrollY > 0) {
		$('header').addClass('fixed')
	} else {
		$('header').removeClass('fixed')
	}
}

